import { Location } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'cims-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PortalComponent implements OnInit {

  constructor(private _location: Location, private router: Router) { }

  ngOnInit() {
    this.router.routeReuseStrategy.shouldReuseRoute = function(){ 
      return false; 
    }
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([this._location.path().replace('/portal', '')], { queryParams : { isPortal : true}});
  }

}



// WEBPACK FOOTER //
// ./src/app/portal/portal.component.ts